export default __webpack_public_path__ + "static/media/emoji_rating.3407af40.svg";